<h2 class="mb-6">What kind of site do you want to create?</h2>

<sbnb-direct-site-type-card
  (clicked)="directAddService.nextStep()"
  [isDisabled]="creatingCustomSite"
  [config]="{
    title: 'Hospitable Site',
    time: '15 minutes',
    list: [
      { text: 'Choose a template and automatically sync your property photos, details and reviews' },
      { text: 'Use your own custom domain or opt for a free Hospitable subdomain' }
    ]
  }"></sbnb-direct-site-type-card>

<sbnb-direct-site-type-card
  (clicked)="createCustomSite()"
  [isLoading]="creatingCustomSite"
  [config]="{
    title: 'Custom Site',
    time: '3-7 days',
    list: [
      { text: 'Build your own website for greater flexibility' },
      { text: 'Add Hospitable’s booking and property search widgets to your custom site' }
    ]
  }">
  <span class="block mt-4">
    Need some help building a custom site?
    <a class="link" target="_blank" href="https://my.hospitable.com/apps">Work with one of our partners</a>
  </span>
</sbnb-direct-site-type-card>

<sbnb-direct-site-type-card
  (clicked)="createCustomSite()"
  [isLoading]="creatingCustomSite"
  [config]="{
    title: 'I already have a website',
    list: [{ text: 'Add Hospitable’s booking and property search widgets to your existing site', hideIcon: true }]
  }"></sbnb-direct-site-type-card>
